import { actionTypes } from '../constants';
import { API } from '../../../vendor/api';
import { canUseExtensions, selectInstitution, } from '../../../store/features/system';
import { loadAndInstallExtension, resetState, } from '../../extensions-framework';
import { selectExtensionsList } from '../selectors';
import { addToast } from '../../core/actions';
import { ToastType } from '../../core/constants';
import { localeService } from '../../core';
import { filterHasNewExtensions } from '../../marketplace-consumer/utils';
export const getInstalledExtensions = (state) => async (dispatch) => {
    try {
        const institution = selectInstitution(state);
        const extensionsList = await API.extensions.getInstalled({
            ...(institution && { institutionId: institution.id }),
        });
        dispatch({
            type: actionTypes.SET_EXTENSIONS,
            payload: extensionsList,
        });
    }
    catch (_e) {
        console.error(_e);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
};
export const setHasNewExtensions = (extensions) => (dispatch) => {
    try {
        const hasNewExtensions = filterHasNewExtensions(extensions);
        dispatch({
            type: actionTypes.SET_HAS_NEW_EXTENSIONS,
            payload: hasNewExtensions,
        });
    }
    catch (error) {
        console.error('setHasNewExtensions', error);
    }
};
export const getAllExtensions = (state) => async (dispatch) => {
    try {
        const institution = selectInstitution(state);
        const extensionsList = await API.extensions.getAll({
            ...(institution && { institutionId: institution.id }),
        });
        dispatch({
            type: actionTypes.SET_EXTENSIONS,
            payload: extensionsList,
        });
        dispatch(setHasNewExtensions(extensionsList));
    }
    catch (_e) {
        console.error(_e);
        const errorMessage = localeService.formatMessageById('notification.extensions-marketplace.server-error');
        dispatch(addToast(ToastType.error, errorMessage));
    }
};
export const loadAndInstallExtensions = () => async (dispatch, getState) => {
    if (canUseExtensions(getState())) {
        await dispatch(getAllExtensions(getState()));
        const extensions = selectExtensionsList(getState());
        const installed = extensions.filter(({ isInstalled, name, sourceCode }) => isInstalled && name && sourceCode);
        await Promise.all(installed.map(async ({ name, sourceCode }) => loadAndInstallExtension(name, sourceCode)));
    }
};
export const resetExtensionsState = () => (dispatch) => {
    resetState();
    dispatch({ type: actionTypes.RESET_STATE });
};
